export enum GraphDisplayMode {
    Line,
    Bar
}
